import $ from "jquery";
import Scrollbar from "smooth-scrollbar";
import Cookies from "js-cookie";

$(document).ready(function () {
    const $mainNav = $('#mainNav');
    if ( !$mainNav.length ) {
        return;
    }

    const $header = $('#header');

    const $menu = {
        list: $mainNav,
        btn: $('#btnMenu'),
        btnClose: $('#btnCloseMenu'),
        overlay: $('#navOverlay'),
        init: function () {
            $menu.btn.on('click', $menu.toggle);
            $menu.btnClose.on('click', $menu.close);
            $menu.list.on('click', '.menuArrow', function (e) {
                if ( innerWidth < 1600 ) {
                    const $arrow = $(this);
                    $arrow.toggleClass('open');
                    $arrow.parents('li').toggleClass('open');
                    $arrow.next('ul').slideToggle();
                }
            });

            Scrollbar.init( $mainNav.find('[data-scrollbar]')[0], {
                continuousScrolling: false,
                damping: 1
            } );

            $(document).on('click', '.mainNav__button', function () {
                $mainNav.toggleClass('collapsed');
                Cookies.set('is_nav_open', !$mainNav.hasClass('collapsed'));
                Scrollbar.init( $mainNav.find('[data-scrollbar]')[0], {
                    continuousScrolling: false,
                    damping: 1
                } );
            });
        },
        toggle: function (e) {
            $menu.isOpen() ? $menu.close(e) : $menu.open(e);
        },
        open: function (e) {
            e.stopPropagation();
            $header.addClass('siteHeader--navVisible');
            $menu.btn.addClass('close');
            $menu.list.addClass('mainNav--visible');
            $menu.overlay.addClass('navOverlay--visible');
            //$body.css('overflow', 'hidden');
        },
        close: function (e) {
            $header.removeClass('siteHeader--navVisible');
            $menu.btn.removeClass('close');
            $menu.list.removeClass('mainNav--visible');
            $menu.overlay.removeClass('navOverlay--visible');
            //$body.css('overflow', '');
        },
        isOpen: function () {
            return $menu.list.hasClass('mainNav--visible');
        }
    };
    $menu.init();
});